/*
 * @Author: WUJUN
 * @Date: 2019-08-12 11:04:17
 * @LastEditTime: 2023-08-30 11:19:45
 * @LastEditors: Please set LastEditors
 * @Description: 定义枚举常量
 */
/**
 * @description: 控件枚举
 * @param {ployType}
 * @return:
 */
export const componentEnum = {
  PAGE: '1', //控件功能-动态页面
  PLOY: '2', //控件功能-动态活动
  REWARD: '3', //控件功能-奖励资源
  FORM: '4' //控件功能-动态表单
};

// 20201201虚拟订单状态
export const orderStateEnumObj = {
  1: '已完成',
  3: '已取消'
};

export const entityOrderStateEnum = {
  TO_BE_PAY: '0', //'待付款',
  TO_BE_SEND: '1', //'待发货',
  TO_BE_RECEIVED: '30', //'待收货',
  COMPLETED: '40', //'已完成',
  CANCELLED: '50', //'已取消'
  REFUNDING: '999' //退款中
};
//实物订单状态
export const entityOrderStateEnumObj = {
  0: '待付款',
  1: '待发货',
  30: '待收货',
  40: '已完成',
  50: '已取消',
  6: '退款中',
  7: '已退款'
};

//
export const redundOrderSateEnum = {
  DELETED: '99', //已删除
  TO_BE_CONFIRM: '10', //待受理
  TO_BE_APPROVAL: '20', //退款中
  TO_BE_REFUND: '30', //待退款 审核完成虚拟待发放，实物待退款
  TO_BE_FINANCE_CONFIRM: '40', // 退款中 待财务确认
  FINANCE_REJECT: '50', //退款中 财务驳回
  COMPLETED: '60', //已完成
  CANCELLED: '70' //已取消
};
//实物退款订单状态
export const redundOrderSateEnumObj = {
  10: '待受理', //待受理
  20: '退款中', //退款中
  30: '退款中', //待退款
  40: '退款中', //待财务确认
  50: '退款中', //退款中
  60: '已退款', //已完成
  70: '已取消 ' //已取消
};

// 默认地址取值
export const defaultAdEnum = {
  yes: 1, // 是默认地址
  no: 0 // 不是默认地址
};
// 商品类型
export const goodsTypeEnumObj = {
  entity: '1', // 实物
  virtual: '2' // 虚拟
};
// 是否是vip价格实物商品
export const vipEntityEnumObj = {
  yes: '1'
};
// 商品限对时间的标签
export const goodsLimitEnumObj = {
  1: '月',
  2: '年',
  3: '终生',
  4: '日',
  5: '周'
};

// 统一规格 为0
export const uniformSpec = '0';

//支付方式
export const payChannel = {
  '110': '支付宝'
};

//订单详情，订单的状态
export const orderCommdityStateEnum = {
  NORMAL: '1', //正常:支付后显示
  REFUNDING: '2', //退款中: 生成退款单时显示
  REFUNDED: '3', //已退款: 退款完成后显示
  CANCELLED: '4', //已取消：订单待支付取消时 显示
  REFUND_EXCEPTION: '5' //退款异常：异常退款时显示
};
export const orderCommdityStateEnumObj = {
  '1': '',
  '2': '退款中',
  '3': '已退款',
  '4': '已取消',
  '5': ''
};

// 20210126配送模板
export const fareModelEnumObj = {
  free: 0, //免运费
  default: 1 //默认运费模板
};

// 20210126 支付方式
export const goodsPayEnum = {
  points: '1', // 友米
  // money: '2', //现金
  moneyAndPoints: '3' //现金+友米
};
export const goodsPayObj = {
  1: '友米', // 友米
  // 2: '现金', //现金
  3: '现金+友米' //现金+友米
};

// 20210126 支付方式
export const refundTypeEnum = {
  points: '1', // 友米
  money: '2', //现金
  moneyAndPoints: '3' //现金+友米
};

export const payIdEnum = {
  ALIPAY: '110',
  WX_H5: '119',
  WX_JSAPI: '120'
};

/**消费记录基础类型  */
export const logBaseTypeEnum = {
  /**加 */
  PLUS: '1',
  /**减少 */
  DECREASE: '2'
};
/**友米减少类型  */
export const logDecreaseTypeEnum = {
  /**兑换 */
  EXCHANGE: '1',
  /**过期 */
  EXPIRE: '2',
  /**扣除 */
  DEDUCT: '3',
  /**参与活动 */
  JOIN_ACTIVITY: '4'
};



// WEBPACK FOOTER //
// src/utils/enum.js